/**
 * Agence'O - filters-trigger
 * @author Axel Baron (Agence'O)
 * @created 14/05/2019
 */

(function ($) {

  /**
   * Action for small filters bar
   */
  $(document).on('click', '.js-filters-trigger', (e) => {
    e.preventDefault();
    e.stopPropagation();
    //vars
    let parent = $(e.currentTarget).parent();
    let filterContainer = parent.find('.listing__filters__content');

    // Close filters
    $('.listing__filter__content').stop().slideUp();
    $('.listing__filter').removeClass('open');

    // Slide toggle filters and change btn text
    filterContainer.stop().slideToggle("fast");
    filterContainer.toggleClass("open");
    if (filterContainer.hasClass('open')) {
      $(e.currentTarget).find('.listing__filters__btn__txt').text('Afficher les filtres');
    } else {
      $(e.currentTarget).find('.listing__filters__btn__txt').text('Masquer les filtres');
    }
  });

  $(document).on('click', '.js-filters-close', (e) => {
    e.preventDefault();
    e.stopPropagation();
    // Close filters
    $('.listing__filters__content').stop().slideUp().removeClass('open');
    $('.listing__filter').removeClass('open');
  });


  /**
   * Action for large filters column
   */
  $(".js-clear-filter").on('click', (e) => {
    e.preventDefault();
    const $this = $(e.currentTarget);
    const target = $this.data('filter');

    $(target).find('input').not(':checkbox, :radio').val('').keyup();
    $(target).find(':checkbox, :radio').prop('checked', false);
    $(target).find('.fake-select__check-number i').text('0');
  });

  $(".js-clear-filter-date").on('click', (e) => {
    e.preventDefault();
    const $this = $(e.currentTarget);
    const target = $this.data('filter');

    $(target).find('input').val('');
  });

}(jQuery));
